const DomesticExpress = () => {
    return (
        
        <div>
            <div className="">
                <img src="/ExpressBanner/banner-1.jpg" width="100%"/>
            </div>
            <div className="flex flex-col justify-center items-center mb-[1.5rem]">
                <hr className="w-[52rem]"/>
                <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5 ">
            
                    <div className="flex flex-col justify-center">
                        <h1 className="font-bold text-3xl text-[#373737]">
                            Domestic Express
                        </h1>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            walk-in customers at various Express Centres across Pakistan, it caters the
                            largest customer base in the country. 
                        </p>
                        <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
                            With a network of more than 900 retail centres in the country and a strong
                            fleet of 4,500+ satellite tracked vehicles, Domestic Express offers its customers
                            a range of cost-effective shipping solutions within Pakistan.
                        </p>
                    </div>
                    <div className="flex-1 flex flex-col justify-center items-center">
                        <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
                    </div>
                </div>
      
            </div>
        </div>
       
    )
};
export default DomesticExpress;